import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import {
	getFilteredCurrentDataBasedOnLevel,
	handleFilterItemSearch
} from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

import {
	clearSelectedFilterName,
	storeItemInGlobalFilter,
	storeSelectedCategory
} from '@store/actions/FilterAction';

const MultiLayerFilter = ({
	filterOptions,
	selectedField,
	selectedMultilevelData,
	allOptions,
	setFilterOptions,
	currentSelectedFilterLevel,
	type,
	isOpenFourthLayerOnSearch = false,
	isReplaceHyphens = true,
	isShowCalander = false
}) => {
	const filterFields = useSelector((store) => store?.filterFieldStore);
	const [dates, setDates] = useState({
		taskGroupFromDate: '',
		taskGroupToDate: ''
	});
	const [isDatePickerEnabled, setIsDatePickerEnabled] = useState(false);
	const ref = useRef();
	const { selectedCheckboxField } = useSelector((store) => store.slectedCheckBoxFieldStore);
	const dispatch = useDispatch();

	const onOutSideClick = () => {
		if (selectedCheckboxField === type) dispatch(clearSelectedFilterName());
	};

	const updateSelectedOptionBasedOnSearch = (nextFilterLevel, item) => {
		dispatch(
			storeSelectedCategory({
				...item,
				filterLevel: nextFilterLevel
			})
		);
	};

	useClickOutside(ref, onOutSideClick);

	const handleDateChange = (e) => {
		const { name, value } = e.target;
		const newDates = {
			...dates,
			[name]: value
		};
		setDates(newDates);

		Object.entries(newDates).forEach(([dateName, dateValue]) => {
			if (dateValue) {
				dispatch(
					storeItemInGlobalFilter({
						name: dateName,
						key: dateValue,
						value: dateValue,
						type: 'INPUT_VALUE',
						identifier: dateName
					})
				);
			}
		});
	};

	useEffect(() => {
		const taskGroupList =
			filterFields?.taskGroupList || filterFields?.DETAILS_PAGE_FILTERS?.taskGroupList || [];
		if (taskGroupList?.length === 0) {
			setIsDatePickerEnabled(false);
			setDates({ taskGroupFromDate: '', taskGroupToDate: '' });
			return;
		}

		const isDateEnabled = taskGroupList.some((item) => {
			return item.checked && (item.key === 'PRESENTED_TO_BUYER' || item.key === 'SELECTED_BY_BUYER');
		});
		setIsDatePickerEnabled(isDateEnabled);
	}, [filterFields]);

	const isOthers = selectedMultilevelData?.some((item) => item?.id === 'OTHERS');

	return (
		<div ref={ref}>
			<FilterName type={type} data={filterOptions} />
			<Checkbox
				data={filterOptions}
				type={type}
				handleSearch={(e) =>
					handleFilterItemSearch(
						e,
						allOptions,
						setFilterOptions,
						updateSelectedOptionBasedOnSearch,
						isOpenFourthLayerOnSearch
					)
				}
				nextFilterLevel={3}
				className="filter-submenu scroll-y-label"
				isFocus={true}
				showSearchBar={true}
				isReplaceHyphens={isReplaceHyphens}
			/>

			{selectedField?.selectedCheckboxField &&
				type === selectedCheckboxField &&
				[3, 4].includes(currentSelectedFilterLevel) && (
					<div className={`filter-submenu  scroll-y-label`} style={{ marginLeft: '235px' }}>
						<Checkbox
							isPrimary={false}
							data={getFilteredCurrentDataBasedOnLevel(3, selectedMultilevelData)}
							type={type}
							nextFilterLevel={4}
							className="" // Do not remove or modify this. Removing it will cause CheckBox to use the default className='filter-submenu scroll-y-label'.
							isFocus={false}
							showSearchBar={false}
							isReplaceHyphens={isReplaceHyphens}
						/>
						{isShowCalander && isOthers && (
							<div className="task-wise-date px-4 py-0">
								<div className="form-group">
									<label
										className={`${isDatePickerEnabled ? '' : 'cursor-none'} regular-14 gray_dark_01`}
										htmlFor="all"
									>
										Task strat date
									</label>
									<input
										type="date"
										id="start_date"
										onChange={handleDateChange}
										name="taskGroupFromDate"
										value={dates.taskGroupFromDate}
										disabled={!isDatePickerEnabled}
										className={`${isDatePickerEnabled ? '' : 'cursor-none'}`}
									/>
								</div>
								<div className="form-group">
									<label
										className={`${isDatePickerEnabled ? '' : 'cursor-none'} regular-14 gray_dark_01`}
										htmlFor="all"
									>
										Task end date
									</label>
									<input
										type="date"
										id="end_date"
										onChange={handleDateChange}
										name="taskGroupToDate"
										value={dates.taskGroupToDate}
										disabled={!isDatePickerEnabled}
										className={`${isDatePickerEnabled ? '' : 'cursor-none'}`}
									/>
								</div>
							</div>
						)}
					</div>
				)}

			{selectedField?.selectedCheckboxField &&
				type === selectedCheckboxField &&
				[4].includes(currentSelectedFilterLevel) && (
					<div className={`filter-submenu  scroll-y-label`} style={{ marginLeft: '470px' }}>
						<Checkbox
							isPrimary={false}
							data={getFilteredCurrentDataBasedOnLevel(4, selectedMultilevelData)}
							type={type}
							nextFilterLevel={5}
							className="" // Do not remove or modify this. Removing it will cause CheckBox to use the default className='filter-submenu scroll-y-label'
							isFocus={false}
							showSearchBar={false}
							isReplaceHyphens={isReplaceHyphens}
						/>
					</div>
				)}
		</div>
	);
};

export default MultiLayerFilter;
